import { Link, useLocation } from "react-router";
import { findNav } from "./nav";

/**
 * Bölüm sekmeleri: aktif menü öğesinin sayfaları (ör. Kişiler → Adaylar |
 * Öğrenciler | …). Tek sayfalı bölümlerde gösterilmez.
 */
export const SectionTabs = () => {
  const { pathname } = useLocation();
  const hit = findNav(pathname);
  if (!hit || hit.section.tabs.length < 2) return null;
  return (
    <nav className="es-tabs" aria-label={`${hit.section.label} sayfaları`}>
      {hit.section.label !== hit.section.tabs[0].label && (
        <span className="es-tabs__section">{hit.section.label}</span>
      )}
      {hit.section.tabs.map((t) => (
        <Link
          key={t.path}
          to={t.path}
          className="es-tab"
          aria-current={t.path === hit.tab.path ? "page" : undefined}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  );
};
